// Property showings across the pipeline — mix of confirmed, pending, completed.
// status: scheduled | confirmed | completed | cancelled | no_show | needs_confirmation

import { daysAgo, daysAhead, hoursAgo, hoursAhead } from './leads.js';

export const showings = [
  {
    id: 'showing-01',
    leadId: 'lead-carlos-mendez',
    propertyId: 'prop-11',
    agentId: 'agent-diego-herrera',
    scheduledAt: hoursAhead(2),
    durationMinutes: 60,
    status: 'confirmed',
    confirmedAt: hoursAgo(1),
    notes: 'Cipriani sales gallery tour followed by unit 2808 visit.',
  },
  {
    id: 'showing-02',
    leadId: 'lead-carlos-mendez',
    propertyId: 'prop-12',
    agentId: 'agent-diego-herrera',
    scheduledAt: hoursAhead(4),
    durationMinutes: 60,
    status: 'confirmed',
    confirmedAt: hoursAgo(1),
    notes: 'Casa Bella sales gallery, B&B Italia furnished model.',
  },
  {
    id: 'showing-03',
    leadId: 'lead-carlos-mendez',
    propertyId: 'prop-02',
    agentId: 'agent-diego-herrera',
    scheduledAt: hoursAhead(34),
    durationMinutes: 45,
    status: 'confirmed',
    confirmedAt: hoursAgo(4),
    notes: 'Ready-to-move comparison at 1000 Biscayne.',
  },
  {
    id: 'showing-04',
    leadId: 'lead-patricia-dubois',
    propertyId: 'prop-03',
    agentId: 'agent-marco-rivera',
    scheduledAt: daysAhead(13),
    durationMinutes: 90,
    status: 'scheduled',
    notes: 'Golden Beach estate, first stop of three-day tour. Private driver.',
  },
  {
    id: 'showing-05',
    leadId: 'lead-patricia-dubois',
    propertyId: 'prop-06',
    agentId: 'agent-marco-rivera',
    scheduledAt: daysAhead(13),
    durationMinutes: 90,
    status: 'scheduled',
    notes: 'Key Biscayne deep-water residence.',
  },
  {
    id: 'showing-06',
    leadId: 'lead-patricia-dubois',
    propertyId: 'prop-01',
    agentId: 'agent-marco-rivera',
    scheduledAt: daysAhead(14),
    durationMinutes: 75,
    status: 'needs_confirmation',
    notes: 'Surfside PH. Waiting on client confirmation after proposed time shift.',
  },
  {
    id: 'showing-07',
    leadId: 'lead-sofia-martinez',
    propertyId: 'prop-05',
    agentId: 'agent-natalia-ortiz',
    scheduledAt: hoursAhead(6),
    durationMinutes: 60,
    status: 'confirmed',
    confirmedAt: hoursAgo(3),
    notes: 'Coral Gables estate. Sofia bringing husband.',
  },
  {
    id: 'showing-08',
    leadId: 'lead-sofia-martinez',
    propertyId: 'prop-07',
    agentId: 'agent-natalia-ortiz',
    scheduledAt: hoursAhead(28),
    durationMinutes: 45,
    status: 'confirmed',
    confirmedAt: hoursAgo(12),
    notes: 'Coconut Grove alternative in Grove village core.',
  },
  {
    id: 'showing-09',
    leadId: 'lead-james-chen',
    propertyId: 'prop-09',
    agentId: 'agent-ana-castillo',
    scheduledAt: daysAhead(4),
    durationMinutes: 60,
    status: 'needs_confirmation',
    notes: 'Mandarin Oriental sales gallery. James still coordinating SF schedule.',
  },
  {
    id: 'showing-10',
    leadId: 'lead-david-rodriguez',
    propertyId: 'prop-05',
    agentId: 'agent-marco-rivera',
    scheduledAt: daysAgo(2),
    durationMinutes: 60,
    status: 'completed',
    completedAt: daysAgo(2),
    notes: 'Second visit with partner. Positive feedback, asked for HOA breakdown.',
  },
];

export const showingsByLeadId = showings.reduce((acc, s) => {
  (acc[s.leadId] = acc[s.leadId] || []).push(s);
  return acc;
}, {});
